/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MachineTranslationSettings } from '../models/MachineTranslationSettings';
import type { MtAddWatermarkRequest } from '../models/MtAddWatermarkRequest';
import type { MtAddWatermarkResponse } from '../models/MtAddWatermarkResponse';
import type { MtPostEditFilesRequest } from '../models/MtPostEditFilesRequest';
import type { MtPostEditFilesResponse } from '../models/MtPostEditFilesResponse';
import type { MtTranslateFilesRequest } from '../models/MtTranslateFilesRequest';
import type { MtTranslateFilesResponse } from '../models/MtTranslateFilesResponse';
import type { MtTranslateTextRequest } from '../models/MtTranslateTextRequest';
import type { MtTranslateTextResponse } from '../models/MtTranslateTextResponse';
import type { PostEditTextRequest } from '../models/PostEditTextRequest';
import type { PostEditTextResponse } from '../models/PostEditTextResponse';
import type { TranslateMediaFilesRequest } from '../models/TranslateMediaFilesRequest';
import type { TranslateMediaFilesResponse } from '../models/TranslateMediaFilesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MachineTranslationService {
    /**
     * Returns text machine translation settings for an authenticated user
     * @returns MachineTranslationSettings Returns machine translation settings
     * @throws ApiError
     */
    public static getMachineTranslationSettings(): CancelablePromise<MachineTranslationSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/machineTranslation/settings',
            errors: {
                400: `bad input parameter`,
            },
        });
    }
    /**
     * translates provided text
     * @returns MtTranslateTextResponse Successful operation
     * @throws ApiError
     */
    public static translateText({
        requestBody,
    }: {
        requestBody?: MtTranslateTextRequest,
    }): CancelablePromise<MtTranslateTextResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/translateText',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad input parameters`,
            },
        });
    }
    /**
     * creates a job request for translating files via MT
     * @returns MtTranslateFilesResponse Successful operation
     * @throws ApiError
     */
    public static translateFiles({
        requestBody,
    }: {
        requestBody?: MtTranslateFilesRequest,
    }): CancelablePromise<MtTranslateFilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/translateFiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad input parameters`,
            },
        });
    }
    /**
     * creates a job request for AI post-editing of translated files
     * @returns MtPostEditFilesResponse Successful operation
     * @throws ApiError
     */
    public static postEditFiles({
        requestBody,
    }: {
        requestBody?: MtPostEditFilesRequest,
    }): CancelablePromise<MtPostEditFilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/postEditFiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad input parameters`,
            },
        });
    }
    /**
     * creates a job request for adding watermarks to files
     * @returns MtAddWatermarkResponse Successful operation
     * @throws ApiError
     */
    public static addWatermark({
        requestBody,
    }: {
        requestBody?: MtAddWatermarkRequest,
    }): CancelablePromise<MtAddWatermarkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/addWatermark',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad input parameters`,
            },
        });
    }
    /**
     * creates a job request for translating media files
     * @returns TranslateMediaFilesResponse Successful operation
     * @throws ApiError
     */
    public static translateMediaFiles({
        requestBody,
    }: {
        requestBody?: TranslateMediaFilesRequest,
    }): CancelablePromise<TranslateMediaFilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/translateMediaFiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad input parameters`,
            },
        });
    }
    /**
     * Post-edits machine translated text to improve quality and accuracy
     * @returns PostEditTextResponse Successful post-editing operation
     * @throws ApiError
     */
    public static postEditText({
        requestBody,
    }: {
        requestBody?: PostEditTextRequest,
    }): CancelablePromise<PostEditTextResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/machineTranslation/actions/postEditText',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad input parameters`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
}
